import React, { useEffect } from "react";
import { Carousel } from 'react-bootstrap';
import '../components/css/CarouselComponent.css';
import "../components/css/blog.css";
import { Container, Row } from "react-bootstrap";
import maskkk from "../components/images/Blog 2.jpg";
import SixCardSlider from "../components/BlogSection/SixCardSlider";

import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

import cc from '../components/images/IMG (31).webp';

import img1 from '../components/images/Blog 1.jpg';
import img2 from '../components/images/Slider 2webp.webp';
import img3 from '../components/images/Slider 3webp.webp';
import img4 from '../components/images/Slider 4webp.webp';
import img5 from '../components/images/Slider 5webp.webp';
import img6 from '../components/images/Slider 6webp.webp';
import { useDispatch, useSelector } from "react-redux";
import { getActiveBlogs } from "../App/Slices/blogSlice";
import { Helmet } from "react-helmet-async";
import MetaData from "../components/MetaData";

const Blogs = ({ mask }) => {
  const dispatch = useDispatch()
  const { activeblogs } = useSelector((state) => state.blogsData);

  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: false,
  });

  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };
  useEffect(() => {
    dispatch(getActiveBlogs())
  }, [dispatch])
  // Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // 3 cards per row
    slidesToScroll: 1, // Smooth one-by-one scroll
    rows: 2, // 2 rows
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768, // For mobile devices
        settings: {
          slidesToShow: 2, // Show 1 card per row on smaller screens
          rows: 1,
        },
      },
      {
        breakpoint: 1024, // For tablets
        settings: {
          slidesToShow: 3,
          rows: 2,
        },
      },
    ],
  };



  const slides = [
    {
      id: 1,
      image: img1,

    },
    // {
    //   id: 2,
    //   image: img2,

    // },

    // {
    //   id: 3,
    //   image: img3,

    // },

    // {
    //   id: 4,
    //   image: img4,

    // },
    // {
    //   id: 5,
    //   image: img5,

    // },
    // {
    //   id: 6,
    //   image: img6,

    // },
  ];
  return (
    <>
      {/* Helmet for SEO */}
      <MetaData
        title={"Advancing Veterinary Care: Knowledge Hub"}
        description={"At PANAV BIOTECH, we are passionate about advancing animal health and wellness. This blog is your go-to destination for insights, updates, and expert knowledge in veterinary pharmaceuticals and animal care."}
        tags={"PANAV BIOTECH"}
      />
      <Helmet>
        <title>Blogs</title>
        <meta name="description" content='At PANAV BIOTECH, we are passionate about advancing animal
                health and wellness. This blog is your go-to destination for
                insights, updates, and expert knowledge in veterinary
                pharmaceuticals and animal care.' />
        <meta property="og:title" content='Advancing Veterinary Care: Knowledge Hub' />
        <meta property="og:description" content='At PANAV BIOTECH, we are passionate about advancing animal
                health and wellness. This blog is your go-to destination for
                insights, updates, and expert knowledge in veterinary
                pharmaceuticals and animal care.' />
        <meta property="og:image" content={maskkk} />
      </Helmet>
      <Carousel interval={3000} fade={true} pause="hover" indicators={true}>
        {slides.map((slide) => (
          <Carousel.Item key={slide.id} className="carousel-item">
            {/* Background Image */}

            <div className="carousel-images-home">
              <img src={slide.image} alt={`Slide ${slide.id}`} className="img-fluid w-100" loading='lazy' />
            </div>


          </Carousel.Item>
        ))}
      </Carousel>

      <section className="blogs-girl-with-dog-section">
        <img src={cc} alt="Welcome " className="left-side-half-circle-blogs" loading='lazy' />
        <Container z>
          <Row ref={ref}>
            {/* Left Column (Image) */}
            <motion.div
              className="col-md-6 col-sm-12 mb-5"
              variants={fadeInUp}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
            >
              <img src={maskkk} className="img-fluid w-100" alt="blogs" />
            </motion.div>

            {/* Right Column (Text) */}
            <motion.div
              className="col-md-6 col-sm-12 text-content-blogs2"
              variants={fadeInUp}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              transition={{ delay: 0.3 }}
            >
              <span>Advancing Veterinary Care: Knowledge Hub</span>
              <p className="pt-3">
                At PANAV BIOTECH, we are passionate about advancing animal
                health and wellness. This blog is your go-to destination for
                insights, updates, and expert knowledge in veterinary
                pharmaceuticals and animal care.
                <br />
                <br />
                Whether you’re a veterinarian, livestock farmer, pet owner, or
                industry professional, we’re here to inform you about the latest
                innovations, trends, and best practices in animal health. From
                cutting-edge research and product highlights to practical tips
                for improving animal care, we aim to support you every step of
                the way.
                <br />
                <br />
                Together, let’s build a healthier and more sustainable future
                for animals and those who care for them. Stay tuned, stay
                informed, and join us in our mission to make a difference.
              </p>
            </motion.div>
          </Row>
        </Container>
      </section>

      <section>
        <SixCardSlider blogs={activeblogs} heading={'Latest Articles'} />
      </section>

      {/* <section>
        <NumberedSlider />
      </section> */}
    </>
  );
};

export default Blogs;
